import { chakra, forwardRef, ImageProps } from "@chakra-ui/react";
import logo from "assets/footerDisclaimerLogos/poweredByBushelLogo.svg";

export const PoweredByBushelLogo = forwardRef<ImageProps, "img">(
  (props, ref) => {
    return <chakra.img src={logo} ref={ref} {...props} />;
  }
);
